import { alertService } from 'components/Varios/alert_service';
import Cargando from 'components/Varios/Cargando';
import Datepicker from 'components/Varios/Datepicker';
import IconCloseModal from 'components/Varios/Modals/IconCloseModal';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { isFeriado, isFeriadoFilter, isWeekday } from 'functions/CalendarFunctions';
import { function_calcular_dias_ordinarios, ObtenerFechaFromIsoFormat, obtener_rango_fechas_no_weekend, PruebaSolucion2, SumarDiasFecha } from 'functions/DatesFunctions';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Card, CardTitle, CardBody, Row, Col, FormGroup, Label, Input, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { CrearSolicitudReplanificacionVacaciones } from './FunctionsSolicitudVacaciones';
import TablePlanificaciones from './TablePlanificaciones';
import { EstadoPlanificacionConSolicitud, FechasPermisosMedicosVacaciones, PlanificacionSolicitudVacaciones, Replanificacion, SolicitudReintegroVacaciones, SolicitudReplanificacionVacacionesPost, SolicitudVacaciones } from './TypesSolicitudVacaciones';

type PropsCardReplanificacionJustificacion = {
    handleOcultarCard: () => void;
    anio: number,
    solicitudes: SolicitudVacaciones[],
    solicitudesReintegro: SolicitudReintegroVacaciones[],
    planificaciones: PlanificacionSolicitudVacaciones[],
    planificacionesNoEjecutadas: PlanificacionSolicitudVacaciones[],
    diasPendientes: number,
    feriados: Date[],
    fechasLicencia: {
        fechadesde: Date,
        fechahasta: Date,
        porcentaje: number
    }[],
    usuarioNoPuedeSolicitarPorAccionPersonal: boolean,
    fechasPermisosMedicos: FechasPermisosMedicosVacaciones[],
    onInsertSolicitud: () => Promise<void>,
    fechaHoraActual: string,
    nroDiasAnticipacion: number

}
export const OPCIONES_SELECT_JUSTIFICACION_PLANIFICACIONES_NO_EJECUTADAS = ["Entrega de información imprevista, a entes de control interno/externo", "Garantizar la continuidad de atención y servicio a la comunidad", "Por razones de necesidad institucional, se anticipan las vacaciones"];

export default function CardReplanificacionJustificacion(props: PropsCardReplanificacionJustificacion) {
    const TITULO_CARD = "Justificación y/o Replanificación de Vacaciones";


    const { handleOcultarCard, anio } = props;

    const todasPlanificaciones = props.planificaciones;


    const fechaActualParaReplanificar = new Date();



    const [planificaciones, setplanificaciones] = useState<PlanificacionSolicitudVacaciones[]>(todasPlanificaciones)

    const [anioSeleccionPlanificacion, setanioSeleccionPlanificacion] = useState<number>(props.anio)

    const [planificacionesMarcadas, setplanificacionesMarcadas] = useState<PlanificacionSolicitudVacaciones[]>([...props.planificacionesNoEjecutadas]);
    const [diasPendientesParaPlanificar, setdiasPendientesParaPlanificar] = useState<number>(props.diasPendientes)
    //States de la planificacion que esta siendo Ingresada
    const [fechaDesdePlanificacion, setfechaDesdePlanificacion] = useState<Date | undefined>(undefined)
    const [fechaHastaPlanificacion, setfechaHastaPlanificacion] = useState<Date | undefined>(undefined)
    const [diaOrdinarioPlanificado, setdiaOrdinarioPlanificado] = useState<number>(0)
    //State de fechas que deben ser omitidas en los Date Picker
    const [fechasReplanificadas, setfechasReplanificadas] = useState<Date[]>([])
    //State de Lista de Replanificaciones
    const [listadoReplanificaciones, setlistadoReplanificaciones] = useState<Replanificacion[]>([])
    //Para radio buttom e indicar si Va a replanificar o no
    const [servidorReplanificara, setservidorReplanificara] = useState<boolean>(true)
    //Justificacion planificaciones no ejecutadas
    const [justificacionPlanificacionesNE, setjustificacionPlanificacionesNE] = useState<string>("")
    const [justificacionReplanificacion, setjustificacionReplanificacion] = useState<string>("")

    //Mostar mensaje de Error al intentar agregar una planificacion al listado
    const [mensajeErrorPlanificacion, setmensajeErrorPlanificacion] = useState<string>("")
    //Mostrar mensaje de Error mientras el listado de replanificaciones no cumpla condiciones
    const [mensajeErrorListadoReplanificaciones, setmensajeErrorListadoReplanificaciones] = useState<string>("")
    //Enviando Respuesta 
    const [loadingCreacion, setloadingCreacion] = useState<boolean>(false)



    const planificacionesPuedenSeleccionarse = planificaciones.filter((v) => (v.estadoParse !== EstadoPlanificacionConSolicitud.EN_EJECUCION && v.estadoParse !== EstadoPlanificacionConSolicitud.EJECUTADO && v.estadoParse !== EstadoPlanificacionConSolicitud.POR_EJECUTAR && v.estadoParse !== EstadoPlanificacionConSolicitud.JUSTIFICACION_INGRESADA))
    console.log(planificacionesPuedenSeleccionarse)
    const listadoAnios: number[] = Array.from(new Set(todasPlanificaciones.map(item => new Date(item.fechaInicio).getFullYear())));


    useEffect(() => {

        var planificacionesDelAnioIndicado = [...todasPlanificaciones].filter((v) => new Date(v.fechaInicio).getFullYear() === anioSeleccionPlanificacion)
        const planifPuedenSeleccionarseDelAnio = planificacionesDelAnioIndicado.filter((v) => (v.estadoParse !== EstadoPlanificacionConSolicitud.EN_EJECUCION && v.estadoParse !== EstadoPlanificacionConSolicitud.EJECUTADO && v.estadoParse !== EstadoPlanificacionConSolicitud.POR_EJECUTAR && v.estadoParse !== EstadoPlanificacionConSolicitud.JUSTIFICACION_INGRESADA))

        //Se coloca el anio que tenga planificaciones seleccionables
        if (planifPuedenSeleccionarseDelAnio.length === 0) {
            const aniosDiferentesAlSeleccionado = listadoAnios.filter(la => la !== anioSeleccionPlanificacion);
            if (aniosDiferentesAlSeleccionado.length > 0) {
                const nuevoAnioElegir = aniosDiferentesAlSeleccionado[0];
                planificacionesDelAnioIndicado = [...todasPlanificaciones].filter((v) => new Date(v.fechaInicio).getFullYear() === nuevoAnioElegir)
                setanioSeleccionPlanificacion(nuevoAnioElegir)
                setplanificaciones(planificacionesDelAnioIndicado)
                setplanificacionesMarcadas([])
            }
            else {
                setplanificaciones(planificacionesDelAnioIndicado)
                setplanificacionesMarcadas([])
            }

            


        }
        else {
            setplanificaciones(planificacionesDelAnioIndicado)
            setplanificacionesMarcadas([])
        }


    }, [anioSeleccionPlanificacion])


    const HandleCheckCelda = useCallback(
        (planificacionSeleccionada: PlanificacionSolicitudVacaciones, e: React.ChangeEvent<HTMLInputElement>) => {



            if (e.target.checked) {
                const nuevaPlanificacionSeleccionada = [...planificacionesMarcadas, planificacionSeleccionada];
                setplanificacionesMarcadas(nuevaPlanificacionSeleccionada);
            }
            else {
                const planificacionDeseleccionada = planificacionesMarcadas.find(p => p.idPlanificacionVacaciones == planificacionSeleccionada.idPlanificacionVacaciones);
                const nuevaPlanificacionSeleccionada = [...planificacionesMarcadas].filter((p => p.idPlanificacionVacaciones !== planificacionDeseleccionada?.idPlanificacionVacaciones))
                setplanificacionesMarcadas(nuevaPlanificacionSeleccionada);
            }
        }, [planificacionesMarcadas])


    const checkReplanificacion = useCallback(
        (planificacionSeleccionada: PlanificacionSolicitudVacaciones) => {

            const checkeada = planificacionesMarcadas.find((v) => v.idPlanificacionVacaciones === planificacionSeleccionada.idPlanificacionVacaciones) !== undefined;
            if (planificacionSeleccionada.estadoParse === EstadoPlanificacionConSolicitud.REPLANIFICACION_INGRESADA || planificacionSeleccionada.estadoParse === EstadoPlanificacionConSolicitud.REPLANIFICADA) {
                return (
                    <input type="checkbox" disabled onChange={(e) => HandleCheckCelda(planificacionSeleccionada, e)}></input>

                )
            }
            else {
                return (
                    <input type="checkbox" checked={checkeada} onChange={(e) => HandleCheckCelda(planificacionSeleccionada, e)}></input>
                )
            }

        }, [planificacionesMarcadas])


    const DatePickerFechaDesde = useMemo(() => {

        var fechaActual = new Date(props.fechaHoraActual);
        var fechaminima = SumarDiasFecha(fechaActual, props.nroDiasAnticipacion);
        var fechamaxima = new Date(fechaActual.getFullYear(), 11, 31)
        if (anioSeleccionPlanificacion > fechaActual.getFullYear()) {
            fechaActual = new Date(anioSeleccionPlanificacion, 0, 1, 0, 0, 0);
            fechaminima = fechaActual;
            fechamaxima = new Date(fechaActual.getFullYear(), 11, 31)
        }




        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })
        var fechasExcluidas: Date[] = [...fechasReplanificadas, ...feriados];

        if (props.fechasLicencia.length > 0) {

            props.fechasLicencia.map((val, ind) => {
                const { fechadesde, fechahasta } = val;
                fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechadesde, fechahasta)]
            })

        }


        //PARA REPLANIFICAR, LOS PERMISOS MEDICOS O POR HORAS, NO IMPIDEN QUE PUEDA IRME ESE DIA DE VACACIONES

        // if (props.fechasPermisosMedicos.length > 0) {

        //     props.fechasPermisosMedicos.map((val, ind) => {
        //         const { fechaDesde, fechaHasta } = val;
        //         fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta)]
        //     })

        // }

        if (listadoReplanificaciones.length > 0) {
            listadoReplanificaciones.map((val, ind) => {
                const { fechaInicio, fechaFin } = val;
                fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechaInicio, fechaFin)]
            })
        }

        var nuevasFechasEscogidas: Date[] = []

        if (props.solicitudes.length > 0) {
            props.solicitudes.map((val, ind) => {
                const { fechaInicio, fechaFin } = val;
                var rangoFechasExcluir = [...obtener_rango_fechas_no_weekend(fechaInicio, fechaFin)]
                const solicitudReintegro = props.solicitudesReintegro.find((v) => v.idSolicitudVacaciones === val.idSolicitud);
                const tieneReintegro = solicitudReintegro !== undefined;
                if (solicitudReintegro !== undefined) {
                    rangoFechasExcluir = [...obtener_rango_fechas_no_weekend(fechaInicio, solicitudReintegro.fechaReintegro)]
                }
                nuevasFechasEscogidas = [...nuevasFechasEscogidas, ...rangoFechasExcluir]

            })

            fechasExcluidas = [...fechasExcluidas, ...nuevasFechasEscogidas]
        }




        return (
            <Datepicker
                value={fechaDesdePlanificacion}
                name="fechadesde"
                id="fechadesde"
                onChange={(e) => setfechaDesdePlanificacion(e)}
                min={fechaminima}
                max={fechamaxima}

                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, props.feriados)}
                showDisabledMonthNavigation={true}
                excludeDates={fechasExcluidas}
                dayClassName={(date: Date) => isFeriado(date, props.feriados)}
                
            />
        )
    }, [fechasReplanificadas, fechaDesdePlanificacion, listadoReplanificaciones, planificacionesPuedenSeleccionarse, props, anioSeleccionPlanificacion])

    const DatePickerFechaHasta = useMemo(() => {

        var fechaActual = new Date();
        var fechaminima = fechaDesdePlanificacion;
        var fechamaxima = new Date(fechaActual.getFullYear(), 11, 31)

        if (anioSeleccionPlanificacion > fechaActual.getFullYear()) {
            fechaActual = new Date(anioSeleccionPlanificacion, 0, 1, 0, 0, 0);
            fechaminima = fechaDesdePlanificacion;
            fechamaxima = new Date(fechaActual.getFullYear(), 11, 31)
        }


        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })
        var fechasExcluidas: Date[] = [...fechasReplanificadas, ...feriados];

        if (props.fechasLicencia.length > 0) {

            props.fechasLicencia.map((val, ind) => {
                const { fechadesde, fechahasta } = val;
                fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechadesde, fechahasta)]
            })

        }

        if (listadoReplanificaciones.length > 0) {
            listadoReplanificaciones.map((val, ind) => {
                const { fechaInicio, fechaFin } = val;
                fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechaInicio, fechaFin)]
            })
        }


        //PARA REPLANIFICAR, LOS PERMISOS MEDICOS O POR HORAS, NO IMPIDEN QUE PUEDA IRME ESE DIA DE VACACIONES

        // if (props.fechasPermisosMedicos.length > 0) {

        //     props.fechasPermisosMedicos.map((val, ind) => {
        //         const { fechaDesde, fechaHasta } = val;
        //         fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta)]
        //     })

        // }

        var nuevasFechasEscogidas: Date[] = []

        if (props.solicitudes.length > 0) {
            props.solicitudes.map((val, ind) => {
                const { fechaInicio, fechaFin } = val;
                var rangoFechasExcluir = [...obtener_rango_fechas_no_weekend(fechaInicio, fechaFin)]
                const solicitudReintegro = props.solicitudesReintegro.find((v) => v.idSolicitudVacaciones === val.idSolicitud);
                const tieneReintegro = solicitudReintegro !== undefined;
                if (solicitudReintegro !== undefined) {
                    rangoFechasExcluir = [...obtener_rango_fechas_no_weekend(fechaInicio, solicitudReintegro.fechaReintegro)]
                }
                nuevasFechasEscogidas = [...nuevasFechasEscogidas, ...rangoFechasExcluir]

            })

            fechasExcluidas = [...fechasExcluidas, ...nuevasFechasEscogidas]
        }




        return (
            <Datepicker
                value={fechaHastaPlanificacion}
                name="fechahasta"
                id="fechahasta"
                onChange={(e) => setfechaHastaPlanificacion(e)}
                min={fechaminima}
                max={fechamaxima}
                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, props.feriados)}
                showDisabledMonthNavigation={true}
                excludeDates={fechasExcluidas}
                dayClassName={(date: Date) => isFeriado(date, props.feriados)}
                
            />
        )
    }, [fechasReplanificadas, fechaDesdePlanificacion, fechaHastaPlanificacion, listadoReplanificaciones, planificacionesPuedenSeleccionarse, props, anioSeleccionPlanificacion])


    useEffect(() => {
        if (fechaDesdePlanificacion !== undefined && fechaHastaPlanificacion !== undefined) {
            const diasOrdinarios = function_calcular_dias_ordinarios(fechaDesdePlanificacion, fechaHastaPlanificacion)
            setdiaOrdinarioPlanificado(diasOrdinarios)
        }
        else {
            setdiaOrdinarioPlanificado(0)
        }
    }, [fechaDesdePlanificacion, fechaHastaPlanificacion])

    useEffect(() => {
        if (!servidorReplanificara || planificacionesMarcadas.length === 0) {
            setlistadoReplanificaciones([])
            setdiaOrdinarioPlanificado(0)
            setfechaDesdePlanificacion(undefined)
            setfechaHastaPlanificacion(undefined)
        }
    }, [servidorReplanificara, planificacionesMarcadas])





    // const onClickAgregarReplanificacion = useCallback(
    //     () => {
    //         const excedeDiasPendientes = (diasPendientesParaPlanificar - diaOrdinarioPlanificado) < 0;
    //         if (excedeDiasPendientes) {
    //             setmensajeErrorPlanificacion("La planificación ingresada excede el número de días disponibles para replanificar. Por favor, escoja otro rango de fechas.");
    //         }
    //         else if (fechaDesdePlanificacion !== undefined && fechaHastaPlanificacion !== undefined) {


    //             const nuevoListadoReplanificacion = [...listadoReplanificaciones, {
    //                 fechaInicio: fechaDesdePlanificacion,
    //                 fechaFin: fechaHastaPlanificacion,
    //                 diasOrdinarios: diaOrdinarioPlanificado
    //             }]

    //             setlistadoReplanificaciones(nuevoListadoReplanificacion)

    //             setfechaDesdePlanificacion(undefined)
    //             setfechaHastaPlanificacion(undefined)

    //             const totalDiasReplanificados = nuevoListadoReplanificacion.reduce((acum, cval) => acum + cval.diasOrdinarios, 0);
    //             const diasDisponiblesParaPlanificar = props.diasPendientes - totalDiasReplanificados;
    //             setdiasPendientesParaPlanificar(diasDisponiblesParaPlanificar)
    //             setmensajeErrorPlanificacion("")

    //         }
    //     },
    //     [diaOrdinarioPlanificado, listadoReplanificaciones, props.diasPendientes, diasPendientesParaPlanificar],
    // )


    const onClickRemoverReplanificacion = useCallback(
        (replanificacionActual: Replanificacion) => {
            if (listadoReplanificaciones.length > 0) {


                const listadoNuevo = [...listadoReplanificaciones].filter((val) => !(val.fechaFin === replanificacionActual.fechaFin && val.fechaInicio === replanificacionActual.fechaInicio))

                setlistadoReplanificaciones(listadoNuevo)



                const totalDiasReplanificados = listadoNuevo.reduce((acum, cval) => acum + cval.diasOrdinarios, 0);
                const diasDisponiblesParaPlanificar = props.diasPendientes - totalDiasReplanificados;
                setdiasPendientesParaPlanificar(diasDisponiblesParaPlanificar)


            }
        },
        [diaOrdinarioPlanificado, listadoReplanificaciones, props.diasPendientes],
    )

    const OnCLickLimpiarReplanificacionAgregando = useCallback(
        () => {
            setdiaOrdinarioPlanificado(0);
            setfechaDesdePlanificacion(undefined);
            setfechaHastaPlanificacion(undefined);
            setmensajeErrorPlanificacion("");
        },
        [],
    )

    useEffect(() => {
        if (fechaDesdePlanificacion !== undefined && fechaHastaPlanificacion !== undefined && diaOrdinarioPlanificado > 0) {


            const excedeDiasPendientes = (diasPendientesParaPlanificar - diaOrdinarioPlanificado) < 0;
            if (excedeDiasPendientes) {
                setmensajeErrorPlanificacion("La planificación ingresada excede el número de días disponibles para replanificar. Por favor, escoja otro rango de fechas.");
            }
            else if (fechaDesdePlanificacion !== undefined && fechaHastaPlanificacion !== undefined) {


                const nuevoListadoReplanificacion = [...listadoReplanificaciones, {
                    fechaInicio: fechaDesdePlanificacion,
                    fechaFin: fechaHastaPlanificacion,
                    diasOrdinarios: diaOrdinarioPlanificado
                }]

                setlistadoReplanificaciones(nuevoListadoReplanificacion)

                setfechaDesdePlanificacion(undefined)
                setfechaHastaPlanificacion(undefined)

                const totalDiasReplanificados = nuevoListadoReplanificacion.reduce((acum, cval) => acum + cval.diasOrdinarios, 0);
                const diasDisponiblesParaPlanificar = props.diasPendientes - totalDiasReplanificados;
                setdiasPendientesParaPlanificar(diasDisponiblesParaPlanificar)
                setmensajeErrorPlanificacion("")

            }
        }

    }, [fechaDesdePlanificacion, fechaHastaPlanificacion, diaOrdinarioPlanificado, listadoReplanificaciones, props.diasPendientes, diasPendientesParaPlanificar, planificacionesMarcadas])


    useEffect(() => {
        if ((props.planificacionesNoEjecutadas.length === 0 || (props.planificacionesNoEjecutadas.length === 1 && props.planificaciones.length === 1)) && props.diasPendientes >= 1) {
            setservidorReplanificara(true)
        }
        else if (props.diasPendientes < 1) {
            setservidorReplanificara(false)
        }


    }, [props.planificacionesNoEjecutadas.length, props.diasPendientes])




    //Este useEffect, verifica que se reprograme una cantidad minima de dias
    useEffect(() => {


        const planificacionesNoEjecutadas = planificacionesMarcadas.filter(srp => srp.estadoParse == EstadoPlanificacionConSolicitud.NO_EJECUTADO);
        const planifMarcadasSonNoEjecutadas = planificacionesNoEjecutadas.length === planificacionesMarcadas.length;
        //EstadoPlanificacionConSolicitud

        const sumaDiasPlanificacionesSeleccionadas = planificacionesMarcadas.reduce((pv, cv) => pv + cv.diasOrdinarios, 0);
        const sumaDiasReplanificaciones = listadoReplanificaciones.reduce((pv, cv) => pv + cv.diasOrdinarios, 0);

        const diasAComparar = props.diasPendientes < sumaDiasPlanificacionesSeleccionadas ? props.diasPendientes : sumaDiasPlanificacionesSeleccionadas;
        const diaCompararSinDecimal = Math.floor(diasAComparar);
        const NoPlanificaMinimo = sumaDiasReplanificaciones < diaCompararSinDecimal;

        if (planificacionesMarcadas.length === 0) {
            setmensajeErrorListadoReplanificaciones("Seleccione planificaciones para realizar una acción");
        }
        else if (NoPlanificaMinimo && servidorReplanificara) {
            setmensajeErrorListadoReplanificaciones("Ud debe reprogramar la misma cantidad de días seleccionados, o hasta un máximo de días pendientes de vacaciones.");
        }
        else if (planifMarcadasSonNoEjecutadas && !servidorReplanificara && justificacionPlanificacionesNE === "") {
            setmensajeErrorListadoReplanificaciones("Selecciones justificación de sus planificaciones no ejecutadas");
        }
        else {
            setmensajeErrorListadoReplanificaciones("")
        }

    }, [planificacionesMarcadas, servidorReplanificara, listadoReplanificaciones, diasPendientesParaPlanificar, props.diasPendientes, justificacionPlanificacionesNE])



    const ComponenteReplanificacionesAgregadas = useMemo(() => {
        const htmlReplanificaciones = listadoReplanificaciones.map((rpl, irpl) => {
            const faIconMinus = "fa fa-solid fa-circle-minus";
            const classNameIconMinus = irpl === 0 ? `${faIconMinus} marginChange` : `${faIconMinus}`;
            return (
                <Row key={"ReplanificacionesDelUsuario" + irpl} className="mt-2">

                    <Col sm={2} md={3}>
                        <FormGroup>

                            {MostrarLabel(irpl, "desdeSolicitud", "Fecha Desde")}

                            <Input type="text" disabled value={ObtenerFechaFromIsoFormat(PruebaSolucion2(rpl.fechaInicio))}></Input>

                        </FormGroup>
                    </Col>
                    <Col sm={2} md={3}>
                        <FormGroup>

                            {MostrarLabel(irpl, "hastaSolicitud", "Fecha Hasta")}

                            <Input type="text" disabled value={ObtenerFechaFromIsoFormat(PruebaSolucion2(rpl.fechaFin))}></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={2} md={2}>
                        <FormGroup>

                            {MostrarLabel(irpl, "diaReplanificacion", "Días ordinarios")}

                            <Input className="text-left" readOnly value={rpl.diasOrdinarios}> </Input>
                        </FormGroup>
                    </Col>
                    <Col sm={1} md={1} className="columnIconMinus">
                        <i
                            className={classNameIconMinus}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Eliminar"
                            onClick={() => onClickRemoverReplanificacion(rpl)}
                        />

                    </Col>
                </Row>
            )
        })

        if (servidorReplanificara) {
            return htmlReplanificaciones;

        }
        else {
            return undefined
        }


    }, [listadoReplanificaciones, servidorReplanificara])

    const ComponenteAgregarReplanificaciones = useMemo(() => {


        const verificaJustificacionReplanificada = (props.planificacionesNoEjecutadas.length <= 1 && ((justificacionReplanificacion !== "" && justificacionReplanificacion !== "def") || (justificacionPlanificacionesNE !== "" && justificacionPlanificacionesNE !== "def"))) || props.planificacionesNoEjecutadas.length > 1

        if (planificacionesMarcadas.length > 0 && servidorReplanificara && verificaJustificacionReplanificada) {
            const tieneDiasDisponiblesParaPlanificar = (props.diasPendientes - CalcularSumaDiasReplanificaciones(listadoReplanificaciones)) > 0;
            const faIconPlus = "fa fa-circle-plus";
            const faIconMinus = "fa fa-circle-minus";

            const classNameIconPlus = listadoReplanificaciones.length === 0 ? `${faIconPlus} marginChange` : `${faIconPlus}`
            const classNameIconMinus = listadoReplanificaciones.length === 0 ? `${faIconMinus} marginChange` : `${faIconMinus}`;
            const htmlComponenteReplanificacion = (
                <>
                    <Row>
                        <Col md={12}>
                            <div className='small-error'>{"Recuerde que la reprogramación debe ser realizada con " + props.nroDiasAnticipacion.toString() + " días de anticipación"}</div>
                        </Col>
                    </Row>
                    <Row className="rowNuevaFechaPlanificacion">
                        <Col sm={2} md={3}>
                            <FormGroup>
                                {MostrarLabel(listadoReplanificaciones.length, "fechaDesde", "Fecha Desde")}
                                {DatePickerFechaDesde}
                            </FormGroup>
                        </Col>
                        <Col sm={2} md={3}>
                            <FormGroup>

                                {MostrarLabel(listadoReplanificaciones.length, "fechaHasta", "Fecha Hasta")}
                                {DatePickerFechaHasta}
                            </FormGroup>
                        </Col>

                        <>
                            <Col sm={2} md={2}>
                                <FormGroup>

                                    {MostrarLabel(listadoReplanificaciones.length, "diaOrdinarioPlanificado", "Días ordinarios")}
                                    <Input className="text-left" readOnly value={diaOrdinarioPlanificado}> </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={1} className="columnIcon">
                                {diaOrdinarioPlanificado > 0 && tieneDiasDisponiblesParaPlanificar && fechaDesdePlanificacion !== undefined && fechaHastaPlanificacion !== undefined &&
                                    <i
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Limpiar"
                                        onClick={() => OnCLickLimpiarReplanificacionAgregando()}
                                        className={classNameIconMinus}
                                    />
                                }
                                {/* {(diaOrdinarioPlanificado <= 0 || !tieneDiasDisponiblesParaPlanificar) &&
                                    <i
                                        className={classNameIconPlus + " disabled"}
                                    />

                                } */}



                            </Col>
                        </>



                    </Row>
                    {mensajeErrorPlanificacion && <small className='small-error'>{mensajeErrorPlanificacion}</small>}
                    {mensajeErrorListadoReplanificaciones &&
                        <>
                            <br />
                            <small className='small-error'>{mensajeErrorListadoReplanificaciones}</small>
                        </>

                    }

                </>

            )

            return htmlComponenteReplanificacion
        }
        else {
            return undefined
        }

    }, [planificacionesMarcadas, listadoReplanificaciones, fechaDesdePlanificacion,
        fechaHastaPlanificacion, diaOrdinarioPlanificado, servidorReplanificara, mensajeErrorPlanificacion, justificacionReplanificacion, justificacionPlanificacionesNE, props.planificacionesNoEjecutadas,
        props.diasPendientes, mensajeErrorListadoReplanificaciones
    ])


    function MostrarLabel(valorValidar: number, forValue: string, textoLabel: string) {
        if (valorValidar === 0) {
            const valorHTML = (
                <Label for={forValue}>
                    {textoLabel}
                </Label>
            )
            return valorHTML;
        }
        else {
            return undefined
        }
    }

    function CalcularSumaDiasReplanificaciones(listadoReplanificaciones: Replanificacion[]) {
        if (listadoReplanificaciones.length === 0) {
            return 0;
        }
        else {
            return listadoReplanificaciones.reduce((acum, repl) => acum + repl.diasOrdinarios, 0);

        }
    }

    function CalcularSumaDiasPlanificacionesSeleccionadas(listadoPlanificaciones: PlanificacionSolicitudVacaciones[]) {
        if (listadoPlanificaciones.length === 0) {
            return 0;
        }
        else {
            return listadoPlanificaciones.reduce((acum, repl) => acum + repl.diasOrdinarios, 0);

        }
    }

    const EnviarSolicitudReplanificacion = useCallback(
        async () => {

            setloadingCreacion(true);
            const idPlanificacionesNoEjecutadas = props.planificacionesNoEjecutadas.map((v, i) => { return v.idPlanificacionVacaciones });
            const idPlanificacionesAnteriores = servidorReplanificara ? planificacionesMarcadas.map((v, i) => { return v.idPlanificacionVacaciones }) : [];

            const creacionSolicitud: SolicitudReplanificacionVacacionesPost = {
                justificacionNoEjecutadas: justificacionPlanificacionesNE,
                justificacionReplanificadas: justificacionReplanificacion,
                listadoReplanificaciones: [...listadoReplanificaciones],
                listadoPlanificacionesNoEjecutadas: idPlanificacionesNoEjecutadas,
                listadoPlanificacionesSeleccionadas: idPlanificacionesAnteriores

            }


            const respuesta = await CrearSolicitudReplanificacionVacaciones(creacionSolicitud);

            if (respuesta.status === 200) {
                alertService.success("Su solicitud de reprogramación ha sido enviada a su Directivo para aprobación. Una vez que la solicitud de reprogramación sea aprobada por el directivo, Ud. debe hacer la solicitud de vacaciones ");
                props.onInsertSolicitud();
            }
            else {
                alertService.error(respuesta.errorMessage);
            }
            props.handleOcultarCard();
            setloadingCreacion(false);


        },
        [listadoReplanificaciones, planificacionesMarcadas, props.planificacionesNoEjecutadas, justificacionPlanificacionesNE, servidorReplanificara, justificacionReplanificacion],
    )


    const BotonCerrar = () => {
        return (
            <IconCloseModal className="closeIconCardReplanificacion" handleClickIcon={() => props.handleOcultarCard()} />
        )
    }

    const botonEnviar = useMemo(() => {

        const verificaJustificacion = props.planificacionesNoEjecutadas.length > 0 && (justificacionPlanificacionesNE !== "" && justificacionPlanificacionesNE !== "def");
        const verifica2 = verificaJustificacion && servidorReplanificara && listadoReplanificaciones.length > 0;
        //const verifica4 = verificaJustificacion && !servidorReplanificara



        const verifica3 = props.planificacionesNoEjecutadas.length === 0 && servidorReplanificara && listadoReplanificaciones.length > 0;





        if (verifica2 || verifica3) {
            return (
                <Row className="justify-content-end">
                    <Col sm={3} md={3} xl={3} className="colContainerButtonReplanificar">
                        <Button onClick={() => EnviarSolicitudReplanificacion()} disabled={mensajeErrorListadoReplanificaciones !== ""}>
                            Aceptar y Enviar
                        </Button>
                    </Col>

                </Row>
            )
        }
        else {
            return undefined;
        }


    }, [servidorReplanificara, listadoReplanificaciones, planificacionesPuedenSeleccionarse, justificacionPlanificacionesNE, props.planificacionesNoEjecutadas, justificacionReplanificacion, mensajeErrorListadoReplanificaciones])


    const onClickSiReplanificara = useCallback(
        (replanificara: boolean) => {
            setservidorReplanificara(replanificara);

        },
        [],
    )

    const componenteJustificacion = useCallback((tipo: "REPLANIFICACION" | "NOEJECUTADA") => {

        return (
            <Row>
                <Col sm={12} md={12}>
                    <FormGroup>
                        <span>
                            <span className='labelJustificacion'>
                                {

                                    tipo === "NOEJECUTADA" &&
                                    <>
                                        {`Justificación de vacaciones planificadas `}
                                        <strong>
                                            NO ejecutadas
                                        </strong>
                                    </>

                                }
                                {
                                    tipo === "REPLANIFICACION" &&
                                    <>
                                        {"Justificación de vacaciones replanificadas"}
                                    </>
                                }
                            </span>

                        </span>

                        <Input
                            type="select"
                            id="justificacionPlanifNoEjec"
                            name="justificacionPlanifNoEjec"
                            value={tipo === "NOEJECUTADA" ? justificacionPlanificacionesNE : justificacionReplanificacion}
                            onChange={(e) => tipo === "NOEJECUTADA" ? setjustificacionPlanificacionesNE(e.target.value) : setjustificacionReplanificacion(e.target.value)}
                            defaultValue={"def"}

                        >
                            <option value={"def"}>Seleccione justificación</option>

                            {
                                OPCIONES_SELECT_JUSTIFICACION_PLANIFICACIONES_NO_EJECUTADAS.map((opcion, indiceOpcion) => {
                                    return (
                                        <option key={"justificacionPlanificacionNoEjec" + indiceOpcion} value={opcion}>{opcion}</option>
                                    )
                                })
                            }


                        </Input>
                    </FormGroup>

                </Col>

            </Row>
        )
    }, [justificacionPlanificacionesNE, justificacionReplanificacion])

    // const botonReplanificacion = useMemo(() => {

    //     const cantidadPlanificaciones = planificacionesstate.length;

    //     const tienePlanificacionesPendientes = planificacionesstate.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.PENDIENTE) !== undefined;
    //     const tienePlanificacionesNoEjecutadas = planificacionesstate.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.NO_EJECUTADO) !== undefined;
    //     const tienePlanificacionesJustificadas = planificacionesstate.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.JUSTIFICADA) !== undefined;

    //     const puedeReplanificar = tienePlanificacionesPendientes || tienePlanificacionesNoEjecutadas || tienePlanificacionesJustificadas;

    //     if (planificacionesstate.length > 0 && puedeReplanificar) {
    //       return (
    //         <Button disabled={planificacionesstate.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.REPLANIFICACION_INGRESADA) !== undefined} onClick={() => props.onClickMostrarReplanificacion()}>
    //           <span className='containerTextReprogVac' >
    //             Reprogramación de vacaciones
    //           </span>
    //         </Button>
    //       )
    //     }
    //     else {
    //       return undefined;
    //     }



    //   }, [planificacionesstate])

    const fechasLicencia = props.fechasLicencia;
    const cantidadPlanificaciones = props.planificaciones.length;
    const tienePlanificacionesPendientes = props.planificaciones.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.PENDIENTE) !== undefined;
    const tienePlanificacionesNoEjecutadas = props.planificaciones.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.NO_EJECUTADO) !== undefined;
    const tienePlanificacionesJustificadas = props.planificaciones.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.JUSTIFICADA) !== undefined;
    const tienePlanificacionesJustificacionIngresada = props.planificaciones.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.JUSTIFICACION_INGRESADA) !== undefined;
    const tieneReplanificacionIngresada = props.planificaciones.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.REPLANIFICACION_INGRESADA) !== undefined;


    const puedeReplanificar = (tienePlanificacionesPendientes || tienePlanificacionesNoEjecutadas || tienePlanificacionesJustificadas) && !tienePlanificacionesJustificacionIngresada && !tieneReplanificacionIngresada;





    function GetMensajeNoPuedeReprogramar(mensaje: string) {
        return (
            <ModalConfirmacion
                show={true}
                size={"md"}
                classNameAllModal={"ModalMensajeNoPuedeReprogramar"}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                mensajeConfirmacion={mensaje}
                nombreBotonAccion={"Cerrar"}
                onClose={() => props.handleOcultarCard()}
                onClick={() => props.handleOcultarCard()}
                centered={true}
            />
        )
    }


    if (fechasLicencia.length > 0 && props.usuarioNoPuedeSolicitarPorAccionPersonal) {//fechasLicencia[0].porcentaje !== 100 && new Date(fechasLicencia[0].fechadesde).getTime() <= fechaActual.getTime() && fechaActual.getTime() <= new Date(fechasLicencia[0].fechahasta).getTime()) {
        const mensajeMostrar = "Ud. se encuentra de licencia o comisión de servicios"
        return (
            GetMensajeNoPuedeReprogramar(mensajeMostrar)
        )
    }
    else if (cantidadPlanificaciones === 0 || planificacionesPuedenSeleccionarse.length === 0 || !puedeReplanificar) {
        const mensajeMostrar = "No tiene planificaciones del presente año disponibles para reprogramar, ó, ya ha ingresado una  solicitud reprogramación que se encuentra en espera de aprobación."
        return (
            GetMensajeNoPuedeReprogramar(mensajeMostrar)
        )
    }

    return (
        <React.Fragment>
            <Modal
                id="modalReprogramacion"
                isOpen={true}
                scrollable={true}
                size={"xl"}
                fullscreen={"xl"}
                centered={false}
                onClosed={() => props.handleOcultarCard()}
                contentClassName="contentReintegro"
            >
                <ModalHeader close={BotonCerrar()}>
                    <div className='tituloModalReprogramacion'>{"Esta es una solicitud de reprogramación/justificación. Una vez aprobada por su directivo, Ud. deberá hacer la solicitud de vacaciones correspondiente. "}</div>
                </ModalHeader>
                <ModalBody className="">
                    <>
                        {
                            <>
                                <div className="containerSelectYearPlanifVac">
                                    <Label>
                                        Seleccione el año del cual desea hacer la reprogramación
                                    </Label>
                                    <select value={anioSeleccionPlanificacion.toString()} onChange={(e) => setanioSeleccionPlanificacion(+e.target.value)}>
                                        {listadoAnios.map((v) => {
                                            return <option value={v.toString()}> {v.toString()}</option>
                                        })}
                                    </select>
                                </div>

                            </>

                        }
                        {
                            loadingCreacion === false &&
                            <Card >
                                <CardTitle className="cardHeaderReplanificacion">
                                    <div>{TITULO_CARD}</div>
                                    {/* <IconCloseModal className="closeIconCardReplanificacion" handleClickIcon={() => props.handleOcultarCard()} /> */}
                                </CardTitle>
                                <CardBody >
                                    <Row>
                                        <Col>
                                            <div>Seleccione las planificaciones que desea replanificar y/o justificar</div>
                                        </Col>
                                    </Row>
                                    <TablePlanificaciones celdaCheck={checkReplanificacion} planificacionesDelAnio={planificacionesPuedenSeleccionarse} anio={anioSeleccionPlanificacion} />
                                    {
                                        props.planificacionesNoEjecutadas.length > 0 &&
                                        <>

                                            {componenteJustificacion("NOEJECUTADA")}
                                        </>

                                    }

                                    {
                                        ((props.planificacionesNoEjecutadas.length > 0 && (justificacionPlanificacionesNE !== "" && justificacionPlanificacionesNE !== "def")) || props.planificacionesNoEjecutadas.length === 0) &&
                                        <Row>
                                            <Col sm={12} md={12}>
                                                <FormGroup tag="fieldset">
                                                    <div className='ParentCheckReplanificar'>
                                                        <div className='textReplanificar'>{"¿Desea replanificar? "}</div>
                                                        <div>
                                                            <FormGroup check inline>

                                                                <Label check>
                                                                    <Input checked={servidorReplanificara} disabled={(props.planificacionesNoEjecutadas.length > 0 && justificacionPlanificacionesNE === "") || (props.planificacionesNoEjecutadas.length === 1 && props.planificaciones.length === 1)} onChange={(e) => onClickSiReplanificara(true)} type="radio" />
                                                                    {"Si"}
                                                                </Label>
                                                            </FormGroup>
                                                            <FormGroup check inline>
                                                                <Label check>
                                                                    <Input checked={!servidorReplanificara} disabled={(props.planificacionesNoEjecutadas.length > 0 && justificacionPlanificacionesNE === "") || (props.planificacionesNoEjecutadas.length === 1 && props.planificaciones.length === 1)} onChange={(e) => onClickSiReplanificara(false)} type="radio" />

                                                                    {"No"}
                                                                </Label>
                                                            </FormGroup>
                                                        </div>

                                                    </div>


                                                </FormGroup>



                                            </Col>
                                        </Row>
                                    }

                                    {servidorReplanificara && props.planificacionesNoEjecutadas.length === 0 &&
                                        componenteJustificacion("REPLANIFICACION")

                                    }

                                    {servidorReplanificara && planificacionesMarcadas.length === 0 && ((props.planificacionesNoEjecutadas.length === 0 && (justificacionReplanificacion !== "" && justificacionReplanificacion !== "def")) || props.planificacionesNoEjecutadas.length > 0) &&

                                        (<>

                                            <Row>
                                                <Col>
                                                    <div>{`Seleccione las planificaciones que desea replanificar.`}</div>
                                                </Col>
                                            </Row>
                                        </>)

                                    }

                                    {servidorReplanificara && planificacionesMarcadas.length > 0 && ((props.planificacionesNoEjecutadas.length === 0 && (justificacionReplanificacion !== "" && justificacionReplanificacion !== "def")) || props.planificacionesNoEjecutadas.length > 0) &&

                                        (<>

                                            <Row>
                                                <Col>
                                                    <div>{`Ud. ha seleccionado ${CalcularSumaDiasPlanificacionesSeleccionadas(planificacionesMarcadas)} día(s) para replanificar. Ud. tiene ${props.diasPendientes} días pendientes por gozar.`}</div>
                                                </Col>
                                            </Row>
                                        </>)

                                    }



                                    {ComponenteReplanificacionesAgregadas}
                                    {ComponenteAgregarReplanificaciones}
                                    {servidorReplanificara && listadoReplanificaciones.length >= 0 &&

                                        <>
                                            <Row className="rowTotalDiasReplanificados mt-4">
                                                <Col sm={4} md={6} className="columnTextTDR">
                                                    <span className='spanTextTDR'>{"Total de días ordinarios replanificados"}</span>
                                                </Col>
                                                <Col sm={2} md={2}>
                                                    <FormGroup className="noMarginbottom">
                                                        <Input type={"text"} className="text-left" readOnly value={listadoReplanificaciones.reduce((ac, r) => ac + r.diasOrdinarios, 0)} />

                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                        </>

                                    }
                                    {
                                        botonEnviar
                                    }


                                </CardBody>
                            </Card>
                        }

                        {
                            loadingCreacion === true &&
                            <Cargando />
                        }


                    </>

                </ModalBody>

            </Modal>


        </React.Fragment>
    )
}
